import { baseUrl } from "../../utils/env";
import axios from "axios";
import {
  CONSUL_ADD_FAIL,
  CONSUL_ADD_REQUEST,
  CONSUL_ADD_SUCCESS,
  CONSUL_DELETE_FAIL,
  CONSUL_DELETE_REQUEST,
  CONSUL_DELETE_SUCCESS,
  CONSUL_DETAILS_FAIL,
  CONSUL_DETAILS_REQUEST,
  CONSUL_DETAILS_SUCCESS,
  CONSUL_LIST_FAIL,
  CONSUL_LIST_REQUEST,
  CONSUL_LIST_SUCCESS,
  CONSUL_UPDATE_FAIL,
  CONSUL_UPDATE_REQUEST,
  CONSUL_UPDATE_SUCCESS,
} from "../constants/honararyConsulConstant";
import { toast } from "react-toastify";

export const listConsul = () => async (dispatch) => {
  try {
    dispatch({ type: CONSUL_LIST_REQUEST });
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const { data } = await axios.get(`${baseUrl}/honorary_consul`, config);

    dispatch({
      type: CONSUL_LIST_SUCCESS,
      payload: data,
    });
  } catch (err) {
    dispatch({
      type: CONSUL_LIST_FAIL,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message,
    });
  }
};
export const detailConsul = (uuid) => async (dispatch) => {
  try {
    dispatch({ type: CONSUL_DETAILS_REQUEST });
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const { data } = await axios.get(
      `${baseUrl}/honorary_consul/${uuid}`,
      config
    );

    dispatch({
      type: CONSUL_DETAILS_SUCCESS,
      payload: data,
    });
  } catch (err) {
    dispatch({
      type: CONSUL_DETAILS_FAIL,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message,
    });
  }
};
export const addConsul =
  (name, joinDate, image, description) => async (dispatch, getState) => {
    try {
      dispatch({ type: CONSUL_ADD_REQUEST });
      const {
        adminLogin: { adminInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${adminInfo.token}`,
        },
      };
      const { data } = await axios.post(
        `${baseUrl}/honorary_consul`,
        {
          name,
          joinDate,
          image,
          description,
        },
        config
      );

      toast.info("Honory Consul Added Successfully", {
        autoClose: 1000,
      });
      dispatch({
        type: CONSUL_ADD_SUCCESS,
        payload: data,
      });
    } catch (err) {
      toast.error("Fail To Add Honory Consul", {
        autoClose: 1000,
      });
      dispatch({
        type: CONSUL_ADD_FAIL,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
  };
export const updateConsul =
  (name, joinDate, image, description, consulId) =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: CONSUL_UPDATE_REQUEST });
      const {
        adminLogin: { adminInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${adminInfo.token}`,
        },
      };
      const { data } = await axios.put(
        `${baseUrl}/honorary_consul/${consulId}`,
        {
          name,
          joinDate,
          image,
          description,
        },
        config
      );

      toast.info("Honorary Consul Updated Successfully", {
        autoClose: 1000,
      });
      dispatch({
        type: CONSUL_UPDATE_SUCCESS,
        payload: data,
      });
    } catch (err) {
      toast.error("Fail To Update Honory Consul", {
        autoClose: 1000,
      });
      dispatch({
        type: CONSUL_UPDATE_FAIL,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
  };
export const deleteConsul = (consulId) => async (dispatch, getState) => {
  try {
    dispatch({ type: CONSUL_DELETE_REQUEST });
    const {
      adminLogin: { adminInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${adminInfo.token}`,
      },
    };
    const { data } = await axios.delete(
      `${baseUrl}/honorary_consul/${consulId}`,
      config
    );

    toast.info("Honorary Consul Delete Successfully", {
      autoClose: 1000,
    });
    dispatch({
      type: CONSUL_DELETE_SUCCESS,
      payload: data,
    });
  } catch (err) {
    toast.error("Fail To Delete Honorary Consul", {
      autoClose: 1000,
    });
    dispatch({
      type: CONSUL_DELETE_FAIL,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message,
    });
  }
};
